import React from 'react';
import { FiShield, FiTrendingUp, FiFeather, FiGrid } from 'react-icons/fi';

const FourPillars = () => {
  const pillars = [
    { icon: <FiShield size={20} aria-hidden />, title: 'Security & Compliance', desc: 'Certified processes and audit-ready reporting.' },
    { icon: <FiTrendingUp size={20} aria-hidden />, title: 'Value Recovery', desc: 'Maximize resale and recovery value.' },
    { icon: <FiFeather size={20} aria-hidden />, title: 'Sustainability', desc: 'Reduce waste with responsible recycling and donation.' },
    { icon: <FiGrid size={20} aria-hidden />, title: 'Scalability', desc: 'Solutions that fit single sites to enterprise scale.' },
  ];
  return (
    <section className="sv-pillars">
      <h2 className="sv-section-title">The Four Pillars</h2>
      <div className="sv-pillars-grid">
        {pillars.map((p, i) => (
          <div className="sv-pillar" key={i}>
            <div className="sv-pillar-icon">{p.icon}</div>
            <div className="sv-pillar-body">
              <h4>{p.title}</h4>
              <p>{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FourPillars;


